var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartePrepayeeIconBlanc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 10.2085C21.2999 8.1439 21.1401 6.95118 20.3767 6.09532C20.2222 5.92219 20.052 5.76207 19.868 5.61679C18.7173 4.7085 16.9937 4.7085 13.5468 4.7085H10.7954C7.3484 4.7085 5.62489 4.7085 4.47421 5.61679C4.29017 5.76207 4.11996 5.92219 3.96553 6.09532C3 7.17779 3 8.79914 3 12.0418C3 15.2845 3 16.9058 3.96553 17.9883C4.11996 18.1615 4.29017 18.3215 4.47421 18.4668C5.62489 19.3752 7.3484 19.3752 10.7954 19.3752H11.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.2915H21.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.2915H21.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 12.9585L19.6435 13.6532C19.8077 13.8147 19.8899 13.8954 19.861 13.964C19.832 14.0326 19.7159 14.0326 19.4836 14.0326H16.6379C15.181 14.0326 14 15.1933 14 16.6252C14 16.9479 14.06 17.2568 14.1696 17.5418M16.4445 20.2918L15.6899 19.5971C15.5256 19.4357 15.4435 19.3549 15.4724 19.2863C15.5013 19.2178 15.6175 19.2178 15.8497 19.2178H18.6954C20.1523 19.2178 21.3333 18.057 21.3333 16.6252C21.3333 16.3024 21.2733 15.9935 21.1638 15.7085",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartePrepayeeIconBlanc);
export default __webpack_public_path__ + "static/media/cartePrepayeeIconBlanc.695a8c040284ec9dea7f95971f3b276a.svg";
export { ForwardRef as ReactComponent };